import { FEATURE_FLAGS } from '@/constants';
import { IFeatureFlag } from '@/types';
import { STU_BASE_PATH, STU_NEW_QUOTE_PATH } from '@/utils/stu/journey';

/**
 * The member flag that opens super top-up to new customers: `RETAIL_SUPER_TOP_UP`, served by SSO
 * from Split.io in `/me`'s `featureFlags`, the same way RHI v2's `RHI_V2` is. Off, or missing, is
 * closed. Not `SUPER_TOP_UP`: that flag belongs to the older ICICI super top-up.
 */
export const isStuOpen = (featureFlags?: IFeatureFlag[] | null) =>
  featureFlags?.find?.((flag) => flag.name === FEATURE_FLAGS.RETAIL_SUPER_TOP_UP)?.enabled === true;

/**
 * Where a closed journey sends someone who opens one of its start pages: the retail health
 * home, where the entry card would be. Never the older ICICI flow, which redirects here once
 * `RETAIL_SUPER_TOP_UP_URL` is set and would loop.
 */
export const STU_CLOSED_REDIRECT_PATH = '/retail/health-insurance';

const STU_START_PATHS = [STU_BASE_PATH, STU_NEW_QUOTE_PATH];

/**
 * The pages that start a new journey, the only ones the flag closes. Every later step needs a
 * quote the customer already has (the backend checks it is theirs), so someone who started, paid
 * or holds a policy keeps reaching it when the flag is turned off, as the backend's `STU_ENABLED`
 * keeps serving them.
 */
export const isStuStartPath = (pathname: string) =>
  STU_START_PATHS.includes(
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname,
  );
